var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDiscover = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 32,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 32,
  fill: "#fff",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#231F20",
  fillRule: "evenodd",
  d: "M4 0h40a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m42 4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h40a2 2 0 0 0 2-2z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#EE7623",
  d: "M46 17.72V28a2 2 0 0 1-2 2H11.92C34 26.22 46 17.72 46 17.72"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#231F20",
  fillRule: "evenodd",
  d: "M4 10.64h1.83a3.17 3.17 0 0 1 3.44 3.21 3.22 3.22 0 0 1-1.15 2.46 3.43 3.43 0 0 1-2.29.74H4zM5.58 16a2.32 2.32 0 0 0 1.71-.55A2.18 2.18 0 0 0 8 13.83a2.15 2.15 0 0 0-.71-1.6 2.35 2.35 0 0 0-1.71-.52h-.33V16z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#231F20",
  d: "M9.85 10.63h1.25v6.42H9.85zM14.17 13.09c-.75-.27-1-.46-1-.8s.39-.72.93-.72c.394.016.76.207 1 .52l.65-.85a2.75 2.75 0 0 0-1.88-.72 1.88 1.88 0 0 0-2 1.84c0 .89.4 1.34 1.57 1.76q.452.144.87.37a.76.76 0 0 1 .38.66.92.92 0 0 1-1 .91 1.48 1.48 0 0 1-1.36-.86l-.81.78a2.49 2.49 0 0 0 2.28 1.22 2.06 2.06 0 0 0 2.2-2.1c0-1.02-.41-1.49-1.83-2.01M16.41 13.84a3.32 3.32 0 0 0 3.39 3.35 3.4 3.4 0 0 0 1.57-.37v-1.47a2 2 0 0 1-1.51.7 2.11 2.11 0 0 1-2.16-2.22 2.13 2.13 0 0 1 2.1-2.2 2.1 2.1 0 0 1 1.57.72v-1.47a3.2 3.2 0 0 0-1.54-.4 3.38 3.38 0 0 0-3.42 3.36M31.3 14.94l-1.72-4.31h-1.36l2.72 6.58h.67l2.78-6.58h-1.36zM34.95 17.05h3.56v-1.09H36.2v-1.73h2.22v-1.09H36.2v-1.42h2.31v-1.09h-3.56z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#231F20",
  fillRule: "evenodd",
  d: "M43.46 12.52A1.72 1.72 0 0 1 42 14.35l2 2.7h-1.52l-1.74-2.58h-.15v2.58h-1.25v-6.41h1.85c1.44 0 2.27.69 2.27 1.88m-2.83 1.06H41c.75 0 1.19-.26 1.19-.94s-.42-1-1.19-1h-.37z",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#EE7623",
  d: "M28.59 13.84a3.41 3.41 0 1 1-3.41-3.41 3.42 3.42 0 0 1 3.41 3.41"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#231F20",
  fillRule: "evenodd",
  d: "M44.11 10.75a.15.15 0 0 1-.11.16l.17.25h-.15l-.18-.24v.24h-.13v-.58h.19c.14 0 .21.06.21.17m-.23-.06v.14h.02c.084 0 .083-.014.08-.054v-.026c0-.06-.04-.06-.1-.06",
  clipRule: "evenodd"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#231F20",
  fillRule: "evenodd",
  d: "M43.596 10.52a.5.5 0 0 1 .344-.15.49.49 0 0 1 .52.5.5.5 0 0 1-1 0 .5.5 0 0 1 .136-.35m.344.75a.33.33 0 0 0 .25-.11.38.38 0 0 0 .13-.29.39.39 0 0 0-.38-.41.4.4 0 0 0-.39.41.39.39 0 0 0 .39.4",
  clipRule: "evenodd"
})));
export default SvgDiscover;